import styled from '@emotion/styled';

export const Grid = styled.div({
  display: 'grid',
  gridGap: 5,
  gridTemplateColumns: 'repeat(auto-fit, minmax(70px, 1fr))',
  gridAutoRows: 50
});

export const PriceButton = styled.button(({ theme, selected }) => ({
  backgroundColor: selected ? theme.color.primary : theme.color.basis5,
  color: selected ? theme.color.white : theme.color.basis2,
  padding: theme.spacing.small,
  width: '100%'
}));
